import { APIMethod, fetchData } from "@client";

export async function removeLabelQuery(id) {
  const res = await fetchData(`/v1/labels/${id}`, APIMethod.DELETE);
  return res.results;
}